import axios from "axios";
import Cookies from "js-cookie";
import { withApiError } from "../utils/apiError";

const BASE_URL = process.env.REACT_APP_BASE_BACKEND_API_URL;

// Fetch the app update config for a single platform (android | ios)
export const getAppUpdateConfig = async (platform) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.get(
      `${BASE_URL}api/v1/app/update-config?platform=${platform}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data);
  } catch (error) {
    console.error(`Error fetching app update config (${platform}):`, error);
    return null;
  }
};

// Update the app update config for a platform
export const updateAppUpdateConfig = async (payload) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.put(
      `${BASE_URL}api/v1/app/update-config`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data);
  } catch (error) {
    console.error("Error updating app update config:", error);
    throw new Error(
      error.response?.data?.message || error.message || "Update failed"
    );
  }
};
